import BaseService from './BaseService'
import { fixImageOrientation } from '@/utils/imageOrientation'

class BusinessInfoService extends BaseService {
  constructor() {
    super('/business-info')
  }

  async getInfo() {
    return this.customRequest('get', '')
  }

  async updateInfo(data) {
    return this.singletonUpdate(data)
  }

  async updateLogo(logoFile) {
    if (!(logoFile instanceof File)) {
      throw new Error('Logo must be a File object')
    }

    const fixedFile = await fixImageOrientation(logoFile)
    const formData = new FormData()
    formData.append('logo', fixedFile)

    return this.customRequest('post', '/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async getLoyaltySettings() {
    return this.customRequest('get', '/loyalty')
  }

  async updateLoyaltySettings(data) {
    return this.customRequest('put', '/loyalty', data)
  }

  async getEcomSettings() {
    return this.customRequest('get', '/ecom')
  }

  async updateEcomSettings(data) {
    return this.customRequest('put', '/ecom', data)
  }

  async getStoreSettings() {
    return this.customRequest('get', '/store')
  }

  async updateStoreSettings(data) {
    return this.customRequest('put', '/store', data)
  }

  async getStoreRedirects() {
    return this.customRequest('get', '/store/redirects')
  }

  async syncStoreRedirects(data) {
    return this.customRequest('put', '/store/redirects', data)
  }

  async getTabSettings() {
    return this.customRequest('get', '/tabs')
  }

  async updateTabSettings(data) {
    return this.customRequest('put', '/tabs', data)
  }

  async getInvoiceSettings() {
    return this.customRequest('get', '/invoices')
  }

  async updateInvoiceSettings(data) {
    return this.customRequest('put', '/invoices', data)
  }

  async getOnlineGateway() {
    return this.customRequest('get', '/payments/online-gateway')
  }

  async updateOnlineGateway(payload) {
    return this.customRequest('put', '/payments/online-gateway', payload)
  }

  /** Dejavoo keyed entry (Sales Register FTD) bootstrap; returns enabled + ftd_security_key when allowed */
  async getKeyedEntryConfig() {
    return this.customRequest('get', '/payments/keyed-entry')
  }

  /** Dejavoo Tap to Pay (in-app) merchant identifiers for native POS clients */
  async getDejavooTopConfig (options = {}) {
    const params = {}
    if (options.platform === 'ios' || options.platform === 'android') {
      params.platform = options.platform
    }
    return this.customRequest('get', '/payments/dejavoo-top', null, { params })
  }

  /** Read-only Dejavoo setup diagnostics (Admin provisions credentials). */
  async getDejavooReadiness() {
    return this.customRequest('get', '/payments/dejavoo-readiness')
  }
}

export const businessInfoService = new BusinessInfoService()
